<template>
  <div class="chart-table">
    <p v-if="data.header_text" class="chart-table__header-title">
      {{ data.header_text }}
    </p>
    <div class="chart-table__select-wrapper">
      <div class="in-select" v-if="sizeVal !== '0'">
        <a
          :class="{ active: selectSizeVal == '1' }"
          @click="() => sizeValSelected('1')"
          >IN</a
        >
        <a
          :class="{ active: selectSizeVal == '2' }"
          @click="() => sizeValSelected('2')"
          >CM</a
        >
      </div>

      <div class="select__right">
        <el-select
          class="select"
          v-if="options.length > 1"
          v-model="value"
          size="mini"
          @change="handleChange"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="(item, index) in options"
            :key="item.name_id"
            :label="item.name || item.name_id"
            :value="index"
          >
          </el-option>
        </el-select>
      </div>

    </div>

    <div
      :style="{
        width: '100%',
        overflow: 'auto',
        paddingBottom: '15px'
      }"
    >
      <table>
        <template v-for="(tr, index) in dataSource">
          <tr :key="index">
            <template v-for="(td, j) in tr">
              <td :key="j">
                <span v-if="selectSizeVal === '1'">
                  {{ td.in_val }}
                </span>
                <span v-else-if="selectSizeVal === '2'">
                  {{ td.cm_val }}
                </span>
                <span v-else>
                  {{ td.val }}
                </span>
              </td>
            </template>
          </tr>
        </template>
      </table>
    </div>

    <p v-if="data.header_text" class="chart-table__footer-text">
      {{ data.footer_text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "SizeChartTable",
  props: {
    data: {
      type: Object,
      require: true,
      default: {},
    },
    options: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dataSource: [], // 当前的表格
      tableData: [],
      value: null,
      selectSizeVal: 0,
      sizeVal: "1",
    };
  },
  mounted() {
    const tableData = this.data?.table_data ?? [];
    const sizeVal = this.data?.size_change ?? "0";
    this.sizeVal = sizeVal;
    this.selectSizeVal = sizeVal;

    if (Array.isArray(tableData) || tableData.length > 0) {
      tableData.forEach((item) => {
        const columns = item.size_columns ?? null;
        const data = item.size_data ?? null;

        if (columns && data) {
          const arr = this.formatArr(columns, data);
          this.tableData.push(arr);
        }
      });
    }

    this.value = 0;
    this.dataSource = this.tableData[0];
  },
  methods: {
    // 选择表格
    handleChange(val) {
      let data = this.tableData[val];

      if (data) {
        this.dataSource = data;
      }
    },

    // 选择尺码标准
    sizeValSelected(val) {
      this.selectSizeVal = val;
    },

    // 格式化表格，格式成可渲染的二维数组
    formatArr(column, data) {
      let arr = [];
      let rowIndex = 0;

      // 单位转换方式， 0， 1， 2
      const sizeVal = this.sizeVal;

      for (let i = 0; i < data.length; i++) {
        const item = data[i];

        if (!item || !Array.isArray(item) || item.length === 0) {
          continue;
        }

        arr[rowIndex] = [];

        column.forEach((col, colIndex) => {
          const colName = col.column;

          for (let j = 0; j < item.length; j++) {
            const td = item[j] || null;
            const tdName = td?.column || null;
            let content = td?.content || null;

            if (tdName !== colName) continue;

            let val = content;
            let inVal = content;
            let cmVal = content;
            const isNum = !Number.isNaN(parseFloat(content));

            // 第一行或者第一列， 不做in->cm计算
            if (colIndex > 0 && rowIndex > 0 && isNum) {
              if (sizeVal === "1") {
                cmVal = (val * 2.54).toFixed(2);
              }
              if (sizeVal === "2") {
                inVal = (val / 2.54).toFixed(2);
              }
            }

            arr[rowIndex].push({
              val,
              in_val: inVal,
              cm_val: cmVal,
            });
          }
        });

        rowIndex++;
      }

      return arr;
    },
  },
};
</script>

<style lang="scss">
.chart-table {
  &__select-wrapper {
    .el-input__inner {
      margin-bottom: 0;
    }
    .el-select-dropdown {
      position: absolute !important;
      top: unset !important;
      text-align: left;
      right: 0 !important;
      left: unset !important;
      .popper__arrow {
        right: 50% !important;
        left: unset !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.chart-table {
  &__header-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
  &__select-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .in-select {
      display: flex;
      align-items: center;
      a {
        cursor: pointer;
        display: inline-block;
        padding: 2px 12px;
        border: 1px solid #222;
        line-height: 1;
        color: #222;
        &.active {
          background: #222;
          color: #fff;
        }
      }
    }
    .select {
      width: 180px;
      &__right {
        flex: 1;
        text-align: right;
      }
    }
  }
  table {
    margin-top: 10px;
    width: 100%;
    border: 1px solid #222;
    text-align: center;
    tr {
      td {
        padding: 6px 12px;
        border: 1px solid #222;
        word-break: keep-all;
        white-space: nowrap;
        span {
          display: inline-block;
          line-height: 16px;
          word-wrap: keep-all;
          white-space: nowrap;
        }
        &:first-child {
          font-weight: bold;
        }
      }
      &:first-child {
        td {
          font-weight: bold;
        }
      }
    }
  }
  &__footer-text {
    margin-top: 12px;
    text-align: center;
    color: #666;
  }
}
</style>
